import refmeLogo from '../../assets/img/refme_logo.png';

const Header = () => {
	return (
		<div className='px-4 shadow-md'>
			<img
				className='h-16'
				src={refmeLogo}
				alt='logo'
			/>
		</div>
	);
};

export default Header;
